import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=788ebaa2&scoped=true&"
import script from "./goodsDetails.vue?vue&type=script&lang=js&"
export * from "./goodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=788ebaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788ebaa2",
  null
  
)

export default component.exports